module.exports = __webpack_public_path__ + "img/ts9.8f281220.png";